import { ITypedReduxAction } from '../../../types/redux/actionType';

export enum EToggleSearchingModalActionType {
  Set = 'settings/toggleSearchingModal/set',
}

export type TToggleSearchingModal = ITypedReduxAction<EToggleSearchingModalActionType.Set, boolean>;
